import type { UserPermission } from '~/domain/dashboard/user/permissions/models/UserPermision'
import type { PdvPermission } from '~/domain/dashboard/user/permissions/models/PdvPermission'

export enum PermissionGroupId {
  Admin = 1,
  SalesPerson = 5
}

export enum PermissionGroupListAction {
  DiscountByProfile = 'discountByProfile'
}

export interface PermissionGroupFeatures {
  hiddenActions?: PermissionGroupListAction[]
}

export interface UserPermissionsGroup {
  id?: number
  name: string
  description: string
  global: boolean
  editable: boolean
  permissions?: UserPermission[]
  pdvPermissions?: PdvPermission[]
  permissionIds?: number[]
}
